'use strict';
import './sass/theme.scss';
import $ from 'jquery';

const importAll = (require) =>
  require.keys().reduce((acc, next) => {
    acc[next.replace('./', '')] = require(next);
    return acc;
  }, {});

const images = importAll(
  require.context('../images', false, /\.(png|jpe?g|svg|gif|jpg)$/)
);

console.log('Test');

const trigger = $(".trigger");
const modal = $(".modal");
const sidebar = $(".mobile-menu-sidebar");

trigger.on('click', ()=>{
  console.log('click trigger');
  sidebar.addClass('open');
  modal.addClass('open');
})

modal.on('click', ()=>{
  console.log('click modal');
  sidebar.removeClass('open');
  modal.removeClass('open');
})

